/**
 * @generated SignedSource<<4c640194e014e14f84e133a806d1d17c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type plusArticleAuthorBlockArticle$data = {
  readonly authors: ReadonlyArray<{
    readonly entityId: string;
    readonly " $fragmentSpreads": FragmentRefs<"authorAvatarAuthor">;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"articleDateContent" | "authorNamesArticle">;
  readonly " $fragmentType": "plusArticleAuthorBlockArticle";
};
export type plusArticleAuthorBlockArticle$key = {
  readonly " $data"?: plusArticleAuthorBlockArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"plusArticleAuthorBlockArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "plusArticleAuthorBlockArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleDateContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorNamesArticle"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Author",
      "kind": "LinkedField",
      "name": "authors",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "entityId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "authorAvatarAuthor"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "e2173abb72a324b8dafc6da3feb8d719";

export default node;
